// import coordinationImg from '../../images/services/coordination.jpg';
import { subTopicImages } from "../servicesData";
import ServiceDetailPage from "../ServiceDetailPage";

const CoordinationWithMerchantBankersAndLegalAdvisors = () => {
  const serviceData = {
    title: "Coordination with Merchant Bankers & Legal Advisors",
    heading: "Coordination with Merchant Bankers & Legal Advisors",
    image:
      subTopicImages["Coordination with Merchant Bankers & Legal Advisors"],
    intro: "Ensuring smooth collaboration across all IPO stakeholders",
    description: [
      "An IPO involves multiple professional parties — merchant bankers, legal counsel, auditors, registrars, printing agencies, tax advisors and regulatory authorities. Coordinating among them requires both technical understanding and disciplined project management.",
      "We act as a professional coordination partner — ensuring that your company’s financial and compliance information is prepared, reviewed and shared efficiently and accurately.",
    ],
    services: [
      {
        title: "Our Support Includes",
        list: [
          "coordinating financial information & documentation",
          "assisting during legal & financial due diligence",
          "replying to clarification requests",
          "supporting preparation of offer documents & disclosures",
          "aligning timelines, data requirements & submissions",
          "facilitating Board and shareholder approvals",
          "managing information flow between stakeholders",
        ],
        extraInfo:
          "This allows promoters and management to focus on business continuity — while the IPO process progresses smoothly in the background.",
      },
    ],
    benefitsIntro: "Outcome",
    benefits: [
      "reduced burden on internal teams",
      "timely milestone completion",
      "clarity across regulatory and advisory partners",
      "fewer process bottlenecks",
    ],
    research:
      "We ensure the IPO process remains structured, professional and well-governed.",
  };

  return (
    <ServiceDetailPage
      {...serviceData}
      overview={serviceData.description}
      services={serviceData.services}
      projects={serviceData.benefits}
    />
  );
};

export default CoordinationWithMerchantBankersAndLegalAdvisors;
